module.exports = "/dist/images/7209f3207d259f0786fd04402902a7be-ticketrest.png";